"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrder = exports.SubmitButton = exports.Main = exports.AcceptDisclaimer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var context_1 = require("../../../context/context");
var hooks_1 = require("../../../hooks/hooks");
var useSubmitOrderButton_1 = require("../../../hooks/useSubmitOrderButton");
var base_1 = require("../../base");
var Components_1 = require("../../Components");
var Components_2 = require("../Components");
var styles_1 = require("../../../styles");
var Steps_1 = require("../Steps");
var hooks_2 = require("../hooks");
var actions_1 = require("../../../context/actions");
var OrderDisplay_1 = require("../../OrderDisplay");
var utils_1 = require("../../../utils");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var lib_1 = require("../../../hooks/lib");
var react_1 = require("react");
var Price = function () {
    var _a = (0, context_1.useTwapContext)(), srcToken = _a.srcToken, dstToken = _a.dstToken;
    var swapPrice = (0, lib_1.useSwapPrice)();
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var usd = (0, hooks_1.useFormatNumberV2)({ value: swapPrice.usd, decimalScale: 2 });
    var price = (0, hooks_1.useFormatNumberV2)({ value: swapPrice.price, decimalScale: 4 });
    return ((0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.DetailRow, __assign({ title: isMarketOrder ? "Market Price" : "Limit Price" }, { children: (0, jsx_runtime_1.jsxs)(StyledPrice, { children: ["1 ", srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol, " = ", price, " ", dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol, " ", (0, jsx_runtime_1.jsx)("span", { children: "($".concat(usd, ")") })] }) })));
};
var StyledPrice = (0, styled_components_1.styled)(styles_1.StyledText)({
    fontSize: 13,
    span: {
        opacity: 0.6,
        fontSize: 12,
    },
});
var StyledWarning = (0, styled_components_1.styled)(Components_1.MarketPriceWarning)({
    justifyContent: "flex-start",
    background: "rgb(27, 27, 27)",
    padding: 8,
    borderRadius: 12,
    ".twap-warning-message": {
        gap: 5,
        fontSize: 14,
    },
    ".twap-warning-message-icon": {
        width: 15,
        height: 15,
        top: 3,
        position: "relative",
    },
});
var MarketWarning = function (_a) {
    var isMarketOrder = _a.isMarketOrder;
    if (!isMarketOrder)
        return null;
    return (0, jsx_runtime_1.jsx)(StyledWarning, { className: "twap-order-modal-market-warning" });
};
var AcceptDisclaimer = function (_a) {
    var className = _a.className;
    var _b = (0, context_1.useTwapContext)(), t = _b.translations, uiPreferences = _b.uiPreferences, state = _b.state;
    var handleDisclaimer = actions_1.stateActions.useHandleDisclaimer();
    var disclaimerAccepted = state.disclaimerAccepted;
    return ((0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.DetailRow, __assign({ className: "twap-order-modal-disclaimer ".concat(className), title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["".concat(t.accept, " "), (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.orbs.com/dtwap-dlimit-disclaimer", target: "_blank" }, { children: t.disclaimer }))] }) }, { children: (0, jsx_runtime_1.jsx)(base_1.Switch, { checked: disclaimerAccepted, onChange: handleDisclaimer }) })));
};
exports.AcceptDisclaimer = AcceptDisclaimer;
var Main = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, context_1.useTwapContext)().state, swapState = _c.swapState, swapSteps = _c.swapSteps;
    var shouldOnlyConfirm = swapState === "loading" && (0, utils_1.size)(swapSteps) === 1;
    if (shouldOnlyConfirm) {
        return (0, jsx_runtime_1.jsx)(ConfirmOrder, {});
    }
    return ((0, jsx_runtime_1.jsxs)(StyledReview, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(Tokens, {}), swapState === "loading" ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledSwapPendingBorder, {}), (0, jsx_runtime_1.jsx)(Steps_1.Steps, {})] })) : ((0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 15 }, { children: [(0, jsx_runtime_1.jsx)(Details, {}), (0, jsx_runtime_1.jsx)(exports.AcceptDisclaimer, {}), (0, jsx_runtime_1.jsx)(exports.SubmitButton, { onClick: onSubmit })] })))] })));
};
exports.Main = Main;
var Tokens = function () {
    var _a = (0, context_1.useTwapContext)(), srcToken = _a.srcToken, dstToken = _a.dstToken;
    var _b = (0, lib_1.useUsdAmount)(), srcUsd = _b.srcUsd, dstUsd = _b.dstUsd;
    var srcAmount = (0, lib_1.useSrcAmount)().amountUi;
    var outAmount = (0, lib_1.useOutAmount)().amountUi;
    var fillDelayMillis = (0, lib_1.useFillDelay)().millis;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var chunks = (0, lib_1.useChunks)();
    return ((0, jsx_runtime_1.jsxs)(OrderDisplay_1.OrderDisplay.Tokens, { children: [(0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.SrcToken, { token: srcToken, amount: srcAmount, usd: srcUsd }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.DstToken, { token: dstToken, amount: outAmount, usd: dstUsd, fillDelayMillis: fillDelayMillis, isMarketOrder: isMarketOrder, chunks: chunks })] }));
};
var Details = function () {
    var chunks = (0, lib_1.useChunks)();
    var _a = (0, context_1.useTwapContext)(), isLimitPanel = _a.isLimitPanel, srcToken = _a.srcToken, dstToken = _a.dstToken;
    var deadline = (0, lib_1.useDeadline)().millis;
    var srcChunkAmount = (0, lib_1.useSrcChunkAmount)().amountUi;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var dstMinAmountOut = (0, lib_1.useDstMinAmountOut)().amountUi;
    var fillDelayMillis = (0, lib_1.useFillDelay)().millis;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Components_1.Separator, {}), (0, jsx_runtime_1.jsxs)(OrderDisplay_1.OrderDisplay.DetailsContainer, { children: [(0, jsx_runtime_1.jsx)(Price, {}), isLimitPanel ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.Expiry, { deadline: deadline }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.Recipient, {}), (0, jsx_runtime_1.jsx)(Fee, {})] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MarketWarning, { isMarketOrder: isMarketOrder }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.Expiry, { deadline: deadline }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.ChunkSize, { srcChunkAmount: srcChunkAmount, srcToken: srcToken }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.ChunksAmount, { chunks: chunks }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.MinDestAmount, { dstToken: dstToken, isMarketOrder: isMarketOrder, dstMinAmountOut: dstMinAmountOut }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.TradeInterval, { fillDelayMillis: fillDelayMillis }), (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.Recipient, {}), (0, jsx_runtime_1.jsx)(Fee, {})] }))] })] }));
};
var Fee = function () {
    var _a = (0, context_1.useTwapContext)(), fee = _a.fee, dstToken = _a.dstToken;
    var outAmount = (0, lib_1.useOutAmount)().amount;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    var amount = (0, react_1.useMemo)(function () {
        if (!fee || !outAmount || isMarketOrder)
            return "";
        return (0, bignumber_js_1.default)(outAmount).multipliedBy(fee).dividedBy(100).toFixed().toString();
    }, [fee, outAmount, isMarketOrder]);
    var amountUi = (0, hooks_1.useFormatNumber)({ value: (0, hooks_1.useAmountUi)(dstToken === null || dstToken === void 0 ? void 0 : dstToken.decimals, amount), decimalScale: 3 });
    if (!fee)
        return null;
    return (0, jsx_runtime_1.jsx)(OrderDisplay_1.OrderDisplay.DetailRow, __assign({ title: "Fee (".concat(fee, "%)") }, { children: amountUi ? "".concat(amountUi, " ").concat(dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol) : "" }));
};
var SubmitButton = function (_a) {
    var onClick = _a.onClick;
    var button = (0, useSubmitOrderButton_1.useSubmitOrderButton)(onClick);
    return ((0, jsx_runtime_1.jsx)(base_1.Button, __assign({ className: "twap-order-modal-submit-btn twap-submit-button", onClick: button.onClick, loading: button.loading, disabled: button.disabled }, { children: button.text })));
};
exports.SubmitButton = SubmitButton;
var StyledReview = (0, styled_components_1.styled)(OrderDisplay_1.OrderDisplay)({});
var StyledSwapPendingBorder = (0, styled_components_1.styled)(Components_1.Separator)({
    margin: "20px 0px",
});
function ConfirmOrder() {
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-create-order-confirm" }, { children: [(0, jsx_runtime_1.jsx)(base_1.Spinner, { size: 55 }), (0, jsx_runtime_1.jsx)(Title, {}), (0, jsx_runtime_1.jsx)(Components_2.SmallTokens, {}), (0, jsx_runtime_1.jsx)(Components_2.BottomContent, { text: "Proceed in your wallet" })] })));
}
exports.ConfirmOrder = ConfirmOrder;
var Title = function () {
    var type = (0, hooks_2.useOrderType)();
    return (0, jsx_runtime_1.jsxs)(styles_1.StyledText, __assign({ className: "twap-order-modal-confirm-title" }, { children: ["Confirm ", type, " order"] }));
};
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 15,
    alignItems: "center",
    ".twap-order-modal-confirm-title": {
        fontSize: 16,
    },
    ".twap-order-modal-confirm-bottom": {
        marginTop: 30,
        color: "rgb(155, 155, 155)",
        fontSize: 14,
    },
});
